import { render, staticRenderFns } from "./modelShowList.vue?vue&type=template&id=4a584bd0&scoped=true"
import script from "./modelShowList.vue?vue&type=script&lang=js"
export * from "./modelShowList.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/lib/modelShowList.scss?vue&type=style&index=0&id=4a584bd0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a584bd0",
  null
  
)

export default component.exports